import React, { useState, useEffect } from "react";

import { useIntl } from "react-intl";
import { connect } from "react-redux";

import Button from "../../UI/Button/Button";
import Headline from "../../Headline/Headline";
import CardSticky from "../../UI/Card/CardSticky"

import Analytics from "./Statistics/Analytics";
import Threshold from "./Statistics/Thresholds";

import * as ContactUtils from "../../Utils/ContactUtils";
import * as AnalyticsActions from "../../../middleware/Store/Actions/AnalyticsActions";
import * as ApplicationsUtils from "../../Utils/ApplicationsUtils";

import { faBackward } from "@fortawesome/free-solid-svg-icons";
import LogService from "../../../middleware/CommonSdk/LogService";
import * as ApplicationConstant from "../../Constants/ApplicationConstant";

const LOG_TAG = "APPLICATION_STATISTICS";

const ApplicationStatistics = (props) => {

    const intl = useIntl();
    const [application, setApplication] = useState();
    const [groupsMapping, setGroupsMapping] = useState(null);

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect location, applications");

        if (ApplicationsUtils.isApplicationStatisticsPath(props.location)) {
            const appId = ApplicationsUtils.getApplicationIdFromLocation(props.location);
            const application = ApplicationsUtils.getApplicationById(appId, props.applications);

            setApplication(application);
        }
    }, [props.location, props.applications, props.user]);

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect didmount, Group of Metrics");
        props.retrieveGroupsOfMetrics()
            .then(data => {
                setGroupsMapping({
                    administration: data.administration,
                    resources: data.resources,
                    webrtc_minutes: data.webrtc_minutes,
                    storage: data.storage,
                    turn: data.turn
                });
            })
            .catch(ErrorPayload => {
                LogService.error(LOG_TAG, "retrieveGroupsOfMetrics error");
            });
    }, []);

    const onReturnToApplications = () => {
        LogService.trace(LOG_TAG, "onReturnToApplications");
        props.history.goBack();
    };

    LogService.info(LOG_TAG, "render");
    const title = intl.messages.applicationStatisticsTitle;
    const subtitle = intl.messages.applicationStatisticsSubTitle;

    const isMyApplication = ApplicationsUtils.isMyApplication(application, props.user);
    const isSuperAdmin = ContactUtils.isSuperAdminOrAppSuperAdmin(props.user);
    const canEdit = (isMyApplication || isSuperAdmin);

    let applicationName = "";
    let tabHeader = [
        <li key="tabHeader_1" className="nav-item">
            <a className="nav-link active"
                id="tab1"
                data-toggle="tab"
                aria-current="page"
                href="#content1"
            >
                {intl.messages.tabMetrics}
            </a>
        </li>
    ];
    let tabContent = [];
    if (application) {
        applicationName = application.name;
        tabContent.push(
            <div key="tabContent_1" id="content1" role="tabpanel" className="tab-pane active">
                <Analytics appId={application.id} groupsMapping={groupsMapping} />
            </div>
        );
        if (application.kpi === ApplicationConstant.ModelType.PayAsYouGo) {
            tabHeader.push(
                <li key="tabHeader_2" className="nav-item">
                    <a className="nav-link"
                        id="tab2"
                        data-toggle="tab"
                        aria-current="page"
                        href="#content2"
                    >
                        {intl.messages.tabThresholds}
                    </a>
                </li>
            );

            tabContent.push(
                <div key="tabContent_2" id="content2" role="tabpanel" className="tab-pane">
                    <Threshold appId={application.id} canEdit={canEdit} groupsMapping={groupsMapping} />
                </div>
            );
        }
    }

    return (
        <div>
            <Headline
                title={title}
                subtitle={subtitle}
            />

            <CardSticky>
                <Button
                    id="backButton"
                    label={intl.messages.applicationEditionBackButton}
                    icon={faBackward}
                    className="btn-primary"
                    onClick={onReturnToApplications}
                />
            </CardSticky>

            <div className="text-center my-5"><h3>{applicationName.toUpperCase()}</h3></div>

            <div className="card-tab">
                <div className="card-header">
                    <ul className="nav nav-tabs card-header-tabs">
                        {tabHeader}
                    </ul>
                </div>

                <div className="card-body" id="tabContent">
                    <div className="tab-content">
                        {tabContent}
                    </div>
                </div >
            </div>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        user: state.contacts.user,
        applications: state.applications.applications,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        retrieveGroupsOfMetrics: () => dispatch(AnalyticsActions.retrieveGroupsOfMetrics())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ApplicationStatistics);